import { BaseApi } from '../base';
import { ApiResponse } from '../../../types/api';

export class GameApi extends BaseApi {
  async getNetworkAvailable(): Promise<ApiResponse> {
    return this.requestWithRetry({
      method: 'GET',
      url: '/v5/ping',
      showLoading: false
    });
  }

  async getConfig(): Promise<ApiResponse> {
    return this.requestWithRetry({
      method: 'GET',
      url: '/v5/config',
      showLoading: false
    });
  }

  async fetchLanguage(url: string): Promise<any> {
    return this.get(url, { showLoading: false });
  }
}